import hrtime from './hrtime.js';

const rAF = typeof document !== 'undefined' && (window.requestAnimationFrame
	|| window.webkitRequestAnimationFrame
	|| window.mozRequestAnimationFrame
	|| window.oRequestAnimationFrame
	|| window.msRequestAnimationFrame).bind(window);

function Looper(fn) {
	this.fn = fn;
	var self = this;
	this._boundTick = function (time) { self._tick(time); };
	this._boundTock = function (time) { self._tock(time); };
	this.running = false;
	this.interval = null;
}

Looper.prototype.start = function () {
	if (this.running) { return; }
	if (rAF) {
		rAF(this._boundTick);
	} else {
		// call the fn right away, so in the fallback case we don’t delay by
		// 16ms
		this.loop();
		var self = this;
		this.interval = setInterval(function () { self.loop(); }, 16);
	}
	this.running = true;
};

Looper.prototype.stop = function () {
	if (!this.running) { return; }
	if (!rAF) {
		clearInterval(this.interval);
		this.interval = null;
	}
	this.running = false;
};

Looper.prototype.loop = function (time) {
	if (typeof time !== 'number') {
		time = hrtime();
	}

	this.fn(time);
};

Looper.prototype._tick = function (time) {
	if (this.running) {
		this.loop(time);
		rAF(this._boundTock);
	}
};

Looper.prototype._tock = function (time) {
	if (this.running) {
		this.loop(time);
		rAF(this._boundTick);
	}
};

export default Looper;



// WEBPACK FOOTER //
// ./lib/pagehandler/utils/looper.js